<template>
  <div
    class="saas-page-content-image"
    :class="{
      'saas-page-content-image--reversed': reversed,
    }"
  >
    <div class="saas-page-content-image__inner">
      <div class="saas-page-content-image__content">
        <h2 class="saas-page-content-image__title">
          {{ block.title }}
        </h2>
        <div
          class="saas-page-content-image__description"
          v-html="block.text"
        ></div>
        <div
          v-if="block.buttons.length > 0"
          class="saas-page-content-image__actions"
        >
          <CmsLink
            v-for="button in block.buttons"
            :key="button.id"
            :url-or-path="button.url_or_path"
            :class="`button button--${button.type} button--large`"
          >
            {{ button.text }}
          </CmsLink>
        </div>
      </div>
      <div class="saas-page-content-image__image">
        <div
          v-if="block.template !== null"
          class="saas-page-content-image__template"
        >
          <div class="saas-page-content-image__template-head">
            <div class="saas-page-content-image__template-icon">
              <i :class="block.template.icon"></i>
            </div>
            <div class="saas-page-content-image__template-name">
              {{ block.template.name }}
            </div>
            <div class="saas-page-content-image__template-action">
              <Button
                tag="nuxt-link"
                :to="{
                  name: 'template-detail',
                  params: { slug: block.template.slug },
                }"
                type="secondary"
                >See more</Button
              >
            </div>
          </div>
          <div
            class="saas-page-content-image__template-image"
            :class="{
              'saas-page-content-image__template-image--padding':
                block.template_image_padding,
            }"
          >
            <img
              v-if="block.image.width_448"
              :src="block.image.width_448.src"
              :alt="block.image.width_448.alt"
              :srcset="`${block.image.width_896.src} 2x`"
            />
          </div>
        </div>
        <img
          v-else-if="block.image.width_448"
          :src="block.image.width_448.src"
          :alt="block.image.width_448.alt"
          :srcset="`${block.image.width_896.src} 2x`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CmsLink from '@saas/components/cms/CmsLink'

export default {
  name: 'PageBlockHorizontalContentImage',
  components: { CmsLink },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reversed() {
      return this.block.direction === 'image_left_content_right'
    },
    srcset() {
      let set = ''
      if (this.block.image.width_896 !== null) {
        set += `${this.block.image.width_896.src} 2x`
      }
      return set
    },
  },
}
</script>
